import React, { useState, useEffect } from "react";
import "./chats-dashboard.css";
import img1 from "../../assets/images/big/bg.jpg";
import share from "../../assets/images/cardLatestNews/share.png";
import view from "../../assets/images/cardLatestNews/view.png";
import shareicon from "../../assets/SVGs/share.svg";
import trash from "../../assets/images/cardLatestNews/trash.png";
import NewLoader from "../styled-components/loader/NewLoader";
import { DatePicker, Select } from "antd";
import { useTheme } from "../../utils/ThemeContext";
import DASHBOARD_API from "../../apis/dashboard.api";
import swal from "sweetalert";

const LatestNews = () => {
  const { theme } = useTheme();

  const [loading, setLoading] = useState();
  const [filterDate, setFilterDate] = useState(null);
  const [newsData,setNewsData] = useState([]);

  const handleDateChange = (date, dateString) => {
    console.log("dateString", dateString);
    setFilterDate(dateString);
  };

  const formatedDateNews = (newsDate) => {
    return new Date(newsDate).toLocaleString("en-US", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const filteredNews = newsData && newsData.filter((news) => {
    if (!filterDate) return true;
    return news.publishedAt.startsWith(filterDate);
  });


  const getLatestNews = async () => {
    try {
      setLoading(true);
      const response = await DASHBOARD_API.fetchNews();

      if (response && response.data) {
        setNewsData(response.data)
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting stock list==>", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getLatestNews();
  }, []);

  const handleClick = (link) => {
    window.open(link, "blank");
  };
  return (
    <div
      className="SavingMainCard2"
      style={{
        position: "relative",
        width: "100%",
        padding: "16px 26px 16px 16px",
        maxHeight: "500px",
        borderRadius: "0px",
        backgroundColor: theme === "dark" ? "#232323" : "white",
      }}>
      <div
        className="latestNewsContainer"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: "6px",
        }}>
        <h3
          className="SavingCardheading"
          style={{
            marginBottom: "20px",
            color: theme === "light" ? "#232323" : "white",
          }}>
          Latest News
        </h3>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "160px",
              border: "1px solid #ededed",
              borderRadius: "6px",
            }}>
            <DatePicker
              onChange={handleDateChange}
              style={{ color: "black" }}
            />
          </div>
        </div>
      </div>

      <div
        className="cardsDivision "
        style={{ maxHeight: "300px", overflowY: "auto" }}>
        {filteredNews && filteredNews.length > 0 ? (
          filteredNews.map((news, index) => (
            <div key={index}>
              <div
                key={index}
                className="latestNewsCard"
                style={{
                  display: "flex",
                  alignItems: "start",
                  marginTop: "16px",
                }}>
                <div  style={{
                  display: "flex",
                  gap:"8px",
                }} 
                onClick={() => {
                  if (news.url) {
                    handleClick(news.url);
                  }
                }}
                >
                <div
                  style={{
                    width: "170px",
                    height: "90px",
                    objectFit: "cover",
                    marginRight: "10px",
                  }}
                  className="latestNewsCardNewsImage">
                  <img
                    alt="cardImg"
                    src={news.urlToImage}
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                    }}></img>
                </div>

                <div
                  className="latestNewsCardNewsDetails"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    width: "100%",
                  }}>
                  <div className="latestNewsCardNewsDetailsHeading">
                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        lineHeight: "16px",
                        letterSpacing: "-0.02em",
                        textAlign: "left",
                        marginBottom: "0px",
                        color: theme === "light" ? "#232323" : "white",
                      }}>
                      {news.title || "title"}
                    </p>

                    <p
                      style={{
                        fontSize: "14px",
                        lineHeight: "16px",
                        letterSpacing: "-0.02em",
                        textAlign: "left",
                        margin: "4px 0",
                        color: theme === "light" ? "#6A6C74" : "#6A6C74",
                      }}>
                      {news.content && news.content.substring(1, 130) + "..."}
                    </p>
                  </div>

                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      lineHeight: "12px",
                      letterSpacing: "-0.02em",
                      textAlign: "left",
                      color: "#6A6C74",
                      marginTop: "4px",
                      marginBottom: "0px",
                    }}>
                    {formatedDateNews(news.publishedAt)}
                  </p>
                </div>
                </div>
                <div
                  className="latestNewsCardNewsAction"
                  style={{
                    display: "flex",
                    // width: "33%",
                    margin: "0 12px",
                    justifyContent: "flex-end",
                    gap: "15px",
                  }}>
                  <div>
                 
                    <img
                      src={shareicon}
                      alt="share"
                      onClick={() => {
                        navigator.clipboard.writeText(news.url);
                        swal("Success", "Copied", "success");
                      }}
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "14px",
                        top: "93px",
                        filter: theme === "dark" ? "invert(1)" : "invert(0)",
                        gap: "0px",
                        opacity: "0.7",
                      }}></img>
                </div>
                  <div>
                    <a
                      href={news.url}
                      target="_blank"
                      style={{padding:"4px"}}
                      rel="noopener noreferrer">
                      <img
                        src={view}
                        alt="share"
                        style={{
                          cursor: "pointer",
                          width: "20px",
                          height: "14px",
                          top: "93px",
                          filter: theme === "dark" ? "invert(1)" : "invert(0)",
                          gap: "0px",
                          opacity: "0.7",
                        }}></img>
                    </a>
                  </div>
                </div>
              </div>
              <hr
                style={{
                  border: "0.1px solid #ededed",
                }}></hr>
            </div>
          ))
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "300px",
              color: "#6A6C74",
              fontWeight: "600",
              fontSize: "20px",
            }}>
            No news for the day
          </div>
        )}
      </div>

      <NewLoader isLoading={loading} />
    </div>
  );
};

export default LatestNews;